import { Edit, translate } from "react-admin";
import React from "react";

import InterestingForm from "./InterestingForm";

const InterestingTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("interesting.interesting")}`}{" "}
      {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Title = translate(InterestingTitle);

export const InterestingEdit = props => (
  <Edit title={<Title />} {...props}>
    <InterestingForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/interesting/InterestingEdit.js